import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { NavBarTab } from "./nav-bar-tab";
import { NavBarDropdown } from "./nav-bar-dropdown";
import { usePermission, useRole } from "../../providers/PermissionsProvider";

export const NavBarTabs = () => {
  const { isAuthenticated } = useAuth0();
  const { can, canAny } = usePermission();
  const { isAdmin, isMember, isCustomer } = useRole();

  // Study Admin: Members management dropdown (granular permissions)
  // Invite redirect still keys off REACT_APP_LIGHTHOUSE_PLATFORM; hide the
  // legacy Send Invitations entry when that platform mode is on.
  const lighthousePlatform = process.env.REACT_APP_LIGHTHOUSE_PLATFORM === 'true';
  const adminDropdownItems = [
    ...(can('admin:survey_management') ? [
      { path: "/admin/survey-management", label: "Survey Management" }
    ] : []),
    ...(canAny(['admin:survey_management', 'admin:invitations']) ? [
      { path: "/admin/lighthouse", label: "Lighthouse" }
    ] : []),
    ...(can('admin:member_funnel') ? [
      { path: "/admin/sample-collections", label: "Member Funnel" }
    ] : []),
    ...(can('admin:sample_intake') ? [
      { path: "/admin/sample-intake", label: "Sample Intake" }
    ] : []),
    ...(can('admin:invitations') && !lighthousePlatform ? [
      { path: "/admin/invite", label: "Send Invitations" }
    ] : []),
    ...(can('admin:current_members') ? [
      { path: "/admin/users", label: "Current Members" }
    ] : []),
    ...(can('admin:prescreen') ? [
      { path: "/admin/pre-screen", label: "Pre-screen Manager" }
    ] : [])
  ];

  // Platform Admin: Org management dropdown
  const orgAdminDropdownItems = [
    ...(canAny(['admin:security', 'admin:provisioning']) ? [
      { path: "/admin/security", label: "Security" }
    ] : []),
    ...(can('org_user:manage') ? [
      { path: "/admin/organization", label: "Organization" }
    ] : [])
  ];

  // Research Tools: Data exploration dropdown
  // Explore = chat:access.
  const exploreDropdownItems = [
    ...(can('chat:access') ? [
      { path: "/admin/cohort-chat", label: "Explore" },
    ] : []),
    ...(can('records_v2:read') ? [
      { path: "/admin/records", label: "Records" }
    ] : []),
    ...(can('admin:workflows') ? [
      { path: "/admin/llm-jobs", label: "Workflows" },
    ] : []),
    ...(can('admin:pipeline') ? [
      { path: "/admin/pipeline", label: "Pipeline" }
    ] : [])
  ];

  // Customer: Account dropdown (enhanced for org_admin)
  const accountDropdownItems = [
    { path: "/profile", label: "Profile" },
    ...(can('org_user:manage') ? [
      { path: "/team", label: "Team" }
    ] : [])
  ];

  return (
    <div className="nav-bar__tabs">
      {isAuthenticated && (
        <>
          {/* MEMBER NAV - Study participants */}
          {isMember && !isAdmin && (
            <>
              <NavBarTab path="/dashboard" label="Dashboard" />
              <NavBarTab path="/profile" label="Profile" />
            </>
          )}

          {/* CUSTOMER NAV - B2B researchers */}
          {isCustomer && !isAdmin && (
            <>
              <NavBarTab path="/chat" label="Chat" />
              {can('records_v2:read') && (
                <NavBarTab path="/admin/records" label="Records" />
              )}
              <NavBarDropdown label="Account" items={accountDropdownItems} />
            </>
          )}
          
          {/* ADMIN NAV - Full access */}
          {isAdmin && (
            <>
              <NavBarTab path="/dashboard" label="Dashboard" />
              <NavBarTab path="/profile" label="Profile" />
              {exploreDropdownItems.length > 0 && (
                <NavBarDropdown label="Explore" items={exploreDropdownItems} />
              )}
              {adminDropdownItems.length > 0 && (
                <NavBarDropdown label="Admin" items={adminDropdownItems} />
              )}
              {orgAdminDropdownItems.length > 0 && (
                <NavBarDropdown label="Org Admin" items={orgAdminDropdownItems} />
              )}
            </>
          )}
        </>
      )}
      
    </div>
  );
};
